// Query-param serializer matching axios 0.x's default.
//
// axios 1.x serializes a nested object param as bracket paths
// (`filters[statuses][0]=Active`), while 0.x JSON-stringified it
// (`filters={"statuses":["Active"]}`). Every list/report endpoint reads it as
// JSON (`JSON.parse(req.query.filters)`), so after the 1.x upgrade the server
// saw no `filters` key at all and silently fell back to unfiltered defaults —
// including showing an agency user campaigns outside the selected client.
// Keep this behavior identical to 0.x so the server contract is unchanged.
const encode = (val) =>
  encodeURIComponent(val)
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");

const serializeParams = (params) => {
  const parts = [];

  Object.entries(params || {}).forEach(([rawKey, rawValue]) => {
    if (rawValue === null || rawValue === undefined) {
      return;
    }

    const isArrayValue = Array.isArray(rawValue);
    const key = isArrayValue ? `${rawKey}[]` : rawKey;
    const values = isArrayValue ? rawValue : [rawValue];

    values.forEach((value) => {
      let serialized = value;
      if (value instanceof Date) {
        serialized = value.toISOString();
      } else if (value !== null && typeof value === "object") {
        serialized = JSON.stringify(value);
      }
      parts.push(`${encode(key)}=${encode(serialized)}`);
    });
  });

  return parts.join("&");
};

export default serializeParams;
